import React, { ReactNode } from 'react';
import { Tooltip } from 'antd';

interface Props {
  title?: string;
  children: ReactNode;
  trigger?: 'click' | 'hover';
  placement?: 'left' | 'top' | 'topLeft' | 'right';
}

export default ({ title = '', children, trigger = 'hover', placement = 'top' }: Props) => (
  <Tooltip placement={placement} title={title} overlayClassName="custom_tooltip" trigger={trigger}>
    {children}
  </Tooltip>
);
